import { injectable, inject } from 'inversify';
import { TYPES } from './modules/http';

import type { IHttpService } from './modules/http';

export interface CaseInfo {
  firstName: string;
  lastName: string;
  canApproveCase: boolean;
  canRejectCase: boolean;
  canProceedCase: boolean;
  canSaveCase: boolean;
  caseId: string;
  caseCode: string;
  surgeryType: string;
  surgeryTypeName: string;
  caseDetailsUrl: string;
  sid: string;
  sub: string;
}

@injectable()
export class CaseInfoApi {
  private _http: IHttpService;

  public constructor(@inject(TYPES.HttpService) http: IHttpService) {
    this._http = http;
  }

  public async getCaseInfo(caseId: string, packageId: string): Promise<CaseInfo> {
    const res = await this._http.get<CaseInfo>('CaseInfo/' + caseId + '/' + packageId);
    return res.data;
  }
}
